export function Item7() {
  return (
    <>
      <p className="text-lg font-medium text-blue-200 mt-6">
        Em um mercado dinâmico e competitivo, as empresas podem enfrentar
        momentos de dificuldade com suas finanças. O acúmulo de dívidas pode
        comprometer o fluxo de caixa, limitar investimentos e até mesmo colocar
        em risco a viabilidade do negócio.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Nesse contexto, a Simya Capital surge como um parceiro estratégico para
        auxiliar na reestruturação de dívidas corporativas. Oferecemos um
        serviço completo e personalizado, com foco na análise da situação
        financeira da empresa, desenvolvimento de um plano personalizado de
        reestruturação, representação nas tratativas com credores, e assessoria
        especializada em todas as etapas do processo de reestruturação.
      </p>
    </>
  );
}
